<div data-testid="sales-order-add-page" class="p-6 max-w-6xl">
  <h2 class="text-2xl font-semibold text-gray-800 mb-6">
    {{ "distribution.sales_order.create_title" | translate }}
  </h2>

  <div class="grid grid-cols-1 md:grid-cols-2 gap-4 mb-6">
    <label class="flex flex-col gap-1">
      <span class="text-sm font-medium">
        {{ "distribution.fields.series" | translate }} *
      </span>
      <input pInputText data-testid="sales-order-series" [(ngModel)]="series" />
    </label>
    <label class="flex flex-col gap-1">
      <span class="text-sm font-medium">
        {{ "distribution.fields.dealer_code" | translate }} *
      </span>
      <input
        pInputText
        data-testid="sales-order-dealer"
        [(ngModel)]="vendorCode"
      />
    </label>
    <label class="flex flex-col gap-1">
      <span class="text-sm font-medium">
        {{ "distribution.fields.delivery_date" | translate }}
      </span>
      <p-datepicker
        data-testid="sales-order-delivery-date"
        [(ngModel)]="deliveryDate"
        dateFormat="dd/mm/yy"
        [minDate]="minDate"
        appendTo="body"
        [showIcon]="true"
      />
    </label>
    <label class="flex flex-col gap-1">
      <span class="text-sm font-medium">
        {{ "distribution.fields.description" | translate }}
      </span>
      <input
        pInputText
        data-testid="sales-order-description"
        [(ngModel)]="description"
      />
    </label>
    @if (salesRequestId(); as requestId) {
      <div class="text-sm text-gray-600 md:col-span-2">
        {{ "distribution.fields.sales_request" | translate }}: #{{ requestId }}
      </div>
    }
  </div>

  <div class="flex items-center justify-between mb-2">
    <h3 class="text-lg font-semibold">
      {{ "distribution.fields.items" | translate }}
    </h3>
    <p-button
      icon="pi pi-plus"
      severity="secondary"
      [outlined]="true"
      [label]="'common.actions.add' | translate"
      (onClick)="addLine()"
    />
  </div>

  <table class="w-full mb-2">
    <thead>
      <tr class="text-left text-sm text-gray-600">
        <th class="p-2">{{ "distribution.fields.sku_code" | translate }} *</th>
        <th class="p-2">{{ "distribution.fields.quantity" | translate }} *</th>
        <th class="p-2">{{ "distribution.fields.unit_price" | translate }}</th>
        <th class="p-2">
          {{ "distribution.fields.warehouse" | translate }} *
        </th>
        <th class="p-2"></th>
      </tr>
    </thead>
    <tbody>
      @for (line of lines(); track $index; let i = $index) {
        <tr>
          <td class="p-2">
            <input
              pInputText
              class="w-full"
              [attr.data-testid]="'sales-order-line-sku-' + i"
              [(ngModel)]="line.skuCode"
            />
          </td>
          <td class="p-2">
            <p-inputnumber
              [attr.data-testid]="'sales-order-line-qty-' + i"
              [(ngModel)]="line.quantity"
              [min]="0"
              [minFractionDigits]="0"
              [maxFractionDigits]="3"
            />
          </td>
          <td class="p-2">
            <p-inputnumber
              [(ngModel)]="line.unitPrice"
              [min]="0"
              [minFractionDigits]="0"
              [maxFractionDigits]="2"
              [placeholder]="'distribution.fields.unit_price_auto' | translate"
            />
          </td>
          <td class="p-2">
            <p-select
              [attr.data-testid]="'sales-order-line-warehouse-' + i"
              [options]="warehouses()"
              [(ngModel)]="line.warehouseCode"
              optionLabel="label"
              optionValue="value"
              [filter]="true"
              appendTo="body"
              styleClass="w-full"
              [placeholder]="'distribution.fields.warehouse' | translate"
            />
          </td>
          <td class="p-2">
            <p-button
              icon="pi pi-trash"
              severity="danger"
              [text]="true"
              [disabled]="lines().length === 1"
              (onClick)="removeLine(i)"
            />
          </td>
        </tr>
      }
    </tbody>
  </table>
  <p class="text-xs text-gray-500 mb-6">
    {{ "distribution.sales_order.price_hint" | translate }}
  </p>

  <div class="flex gap-2">
    <p-button
      data-testid="sales-order-save-btn"
      [label]="'common.actions.save' | translate"
      [loading]="saving()"
      (onClick)="onSave()"
    />
    <p-button
      severity="secondary"
      [outlined]="true"
      [label]="'common.actions.cancel' | translate"
      (onClick)="onBack()"
    />
  </div>
</div>

<p-toast />
